// Dizayn tokenlari — YAGONA manba, xsib-admin naqshi bilan bir xil.
//
// antd v5 CSS-in-JS ishlatadi va butun komponentlar palitrasini shu
// tokenlardan HOSIL QILADI — bitta qiymat o'zgarsa, karta, forma va modal
// birgalikda o'zgaradi. Ikkinchi manba yaratmang: komponent ichida qattiq
// rang yozilsa, tema almashganda o'sha joy qorayib qoladi.

import { theme, type ThemeConfig } from 'antd'

const FONT_FAMILY =
  "'Inter Variable', Inter, ui-sans-serif, system-ui, 'Segoe UI', Roboto, sans-serif"

// Brend to'q sarig'i (#ED4325) oq matn bilan AA bermaydi; bu soya 4.63:1.
const BRAND_PRIMARY = '#D9381E'
// Xato rangi to'q sariqdan ajralib tursin, aks holda «xavfli» tugma asosiy tugmadek ko'rinadi.
const DANGER = '#cf1322'
// Matn sifatida ishlatilganda (havola, tanlangan tab) fonga nisbatan 4,5 dan past tushmasin
const PRIMARY_TEXT = { light: '#C4311A', dark: '#F26A4F' } as const

/** Ikkala rejimda ham bir xil qoladigan tokenlar */
const sharedToken = {
  borderRadius: 12,
  fontFamily: FONT_FAMILY,
  fontSize: 15,
  wireframe: false,
} as const

export const lightTheme: ThemeConfig = {
  algorithm: theme.defaultAlgorithm,
  token: {
    ...sharedToken,
    colorPrimary: BRAND_PRIMARY,
    colorLink: PRIMARY_TEXT.light,
    colorPrimaryText: PRIMARY_TEXT.light,
    colorWarningText: '#b45309',
    colorSuccessText: '#15803d',
    colorInfo: '#2563eb',
    colorSuccess: '#16a34a',
    colorWarning: '#d97706',
    colorError: DANGER,
    colorBgLayout: '#f2f5fa',
  },
  components: {
    Layout: {
      headerBg: '#ffffff',
      bodyBg: '#f2f5fa',
    },
    Card: {
      borderRadiusLG: 16,
    },
  },
}

export const darkTheme: ThemeConfig = {
  algorithm: theme.darkAlgorithm,
  token: {
    ...sharedToken,
    colorPrimary: BRAND_PRIMARY,
    // Qorong'i fonda matn havolasi uchun `BRAND_PRIMARY` kontrasti yetmaydi
    colorLink: '#FF8466',
    colorPrimaryText: PRIMARY_TEXT.dark,
    colorPrimaryTextHover: '#F58A73',
    colorError: '#ff5c5c',
    colorErrorText: '#ff7875',
    colorInfo: '#3b82f6',
    colorSuccess: '#22c55e',
    colorWarning: '#eab308',

    colorBgBase: '#080d18',
    colorBgLayout: '#080d18',
    colorBgContainer: '#101828',
    colorBgElevated: '#161f33',
    colorBorder: '#212f47',
    colorBorderSecondary: '#1b273c',
    colorText: '#e2e8f0',
    colorTextSecondary: '#94a3b8',
    colorTextTertiary: '#64748b',
  },
  components: {
    Layout: {
      headerBg: '#0b1220',
      bodyBg: '#080d18',
    },
    Card: {
      borderRadiusLG: 16,
    },
  },
}
